import React, { Component } from 'react';
import queryString from 'query-string'
import Cookies  from 'universal-cookie';
import  axios  from 'axios';
import { VkGroupBlock } from './VkGroupBlock';
import { HorizontalLine } from './HorizontalLine';
import { LineProgressBar } from '@frogress/line';
import LeftArrowIcon from './LeftArrowIcon';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';


export class VkCodeCallback extends React.Component {


    //access_token = "85c6c60137bbaecd35ec42678d24b29b14f30781dd812202d63ad99cc7846d8da0114a83d21803773cc86";
    
    state = {
        chosen_group_id : null,
        items : [],
        stage : '75_vk',
        showProgressNum : true,
        infoBlock: '',
        successMsg : '',
        showSuccessMsg : false,
        stageNum: 4    }

    constructor(props) {
        super(props);
        
        
        const value = queryString.parse(window.location.search);
        const code = value.code;
        
        this.code = code
        this.chooseGroup = this.chooseGroup.bind(this)
    }

    componentDidMount() {
        const cookies = new Cookies();
        cookies.set('vk_code', this.code, {path : '/'})  

        if (cookies.get('errorBack')) {

            alert("Попробуйте снова");

        }

        cookies.remove('errorBack', {path: '/'})
        if (cookies.get('vk_access_token'+this.code,  {path : '/'})) {
            axios.get(process.env.REACT_APP_BACKEND_SERVER+'/VkGroups?access_token='+ cookies.get('vk_access_token'+this.code,  {path : '/'}) , {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                
                console.log(res.data)
                this.setState((prevState) => {
                    return  {
                           ...prevState,
                           items : res.data.res.response.items
                       };
               }, () =>  {
                   
               }) 

                
                
            })
            .catch(err => {
            console.log(err);
            })
        }
        else {
            
            axios
            .post( process.env.REACT_APP_BACKEND_SERVER+'/VkGetTokenByCode/', {
                
                'code' : this.code
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                console.log(res.data)
                if (res.data.status == 'ok') {
                    
                    this.access_token = res.data.res.access_token
                    cookies.set('vk_access_token'+this.code, this.access_token, {path : '/'}) 
                    
                    //console.log(this.access_token )
                    axios.get(process.env.REACT_APP_BACKEND_SERVER+'/VkGroups?access_token='+this.access_token , {
                        headers : {
                            'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                        }
                    } )
                    .then(res => {
                        
                        console.log(res.data)
                        this.setState((prevState) => {
                            return  {
                                   ...prevState,
                                   items : res.data.res.response.items
                               };
                       }, () =>  {
                           
                       }) 
        
                        
                        
                    })
                    .catch(err => {
                    console.log(err);
                    })
                    
                }
            })
            .catch(err => {
            console.log(err);
            })
        }
        

        
        
        
        
        
    }

    chooseGroup(e, val) {
        
        const cookies = new Cookies();
         
        cookies.set('vk_group_id', val, {path : '/'});
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   chosen_group_id : val
               };
       }, () =>  {
           
       })   

    }


    render() {
        return (
                    <div className='createPage'>
                                <div className="createPageTitle">
                                    <h1 style={{marginBottom:"0.15em"}}> { this.props.title ? this.props.title : "Создать чат-бот+виджет"}</h1>
                                    <HorizontalLine />
                                </div>
                                <div className='createWidgetMainBlock'>
                                    <div className="createWidgetMainBlock__progressBar">
                                        <div className="createWidgetMainBlock__progressBar_label">
                                            Этап:
                                        </div>
                                        
                                    <LineProgressBar
                                        transition={{ easing: 'linear' }}
                                        label={(value) => <div>  <span className={this.state.showProgressNum ? "progressBar_etaps" : "progressBar_etaps hidden"}><span className='progressBar_etaps_blue'>{value * this.state.stageNum / 100}</span>   /   {this.state.stageNum} </span> </div>} 
                                        percent={parseInt(this.state.stage.split('_')[0])}
                                        rounded={36}
                                        height={'2.4em'}
                                        progressColor="linear-gradient(90deg, #31D0E1 3.43%, #0868F5 86.29%);"
                                        containerColor="#FFF" />`
                                    </div>
                                    
                                <div onClick={ () => {
                                    window.location.href = '/createwidget'
                                }} className="createWidgetMainBlock_back">< LeftArrowIcon /> Назад</div> 
                
            <div className='whiteBlock' style={{ marginTop: '3em', width: '49em'}}>
                <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Выберите группу:
                            </div>
                        </div>
                <div className='VkGroupsBlock WhiteBlockMiddle grayScroll'>
                    
                    
                    {
                            this.state.items.map(item => {
                                return (
                                    <VkGroupBlock 
                                    img={item.photo_50} 
                                    group_name={item.name} 
                                    group_id={item.id} 
                                    chosen_group_id={this.state.chosen_group_id}
                                    chooseGroup={this.chooseGroup}
                                    link={'https://vk.com/' + item.screen_name}
                                    />
                                );
                                })
                                }

                       

                </div>
                
                <div className='whiteBlockButtonBlock'> 
                    <a className='whiteBlockButton' href={ 'https://oauth.vk.com/authorize?client_id='+ process.env.REACT_APP_VK_CLIENT_ID +'&redirect_uri='+ process.env.REACT_APP_VK_REDIRECT_URI +'&scope='+ process.env.REACT_APP_VK_SCOPE +'&display=page&groupId='+ this.state.chosen_group_id +'&group_ids='+this.state.chosen_group_id } >Далее</a></div>
            </div>
            
        </div>         
        </div>                             
        )
    }
}